import PropTypes from 'prop-types';

export default function Heading({ title, description, type = 'h2' }) {
	const HeadingTag = type;

	return (
		<div className="feature__heading">
			<hgroup className="feature__heading">
				<HeadingTag className="feature__heading--headline">{title}</HeadingTag>
				<p className="feature__heading--sub-headline text-subline">{description}</p>
			</hgroup>
		</div>
	);
}

Heading.propTypes = {
	title: PropTypes.string,
	description: PropTypes.string,
	type: PropTypes.string,
};
